module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Hazel_10.35edd054.png";